import Icon from '@ant-design/icons';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { Button } from 'antd';
import { ReactComponent as LinkIcon } from 'assets/icons/forwardCurrentColor.svg';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { useMemo } from 'react';

const PricingLinkComponent = () => {
  const { t } = useTranslate();
  const systemLanguage = useSystemLanguageValue();

  const href = useMemo(() => {
    const supportLang = ['zh-CN', 'en-US', 'id', 'vi'];
    if (supportLang.includes(systemLanguage)) {
      return `https://chatplus.ai/${systemLanguage}/pc/price.html`;
    }
    return `https://chatplus.ai/en-US/pc/price.html`;
  }, [systemLanguage]);

  return (
    <PricingLink type="link" href={href} target="_blank" icon={<Icon component={LinkIcon} />}>
      {t('scene.managementCenter.sellerPlan.subscriptionTab.action.seeAllPlanFeatures')}
    </PricingLink>
  );
};

export default PricingLinkComponent;

const PricingLink = styled(Button)`
  padding: 0;
  color: var(--fett-text-secondary);

  &:hover {
    color: var(--ant-primary-color);
  }
`;
